import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const GoogleDriveOutline: React.FC<Props> = ({ width, height, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
    >
      <g fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M16 9.079h-5.195L5.706 0h4.309c.548 0 1.055.3 1.33.79L16 9.078zm-.077 1.184L13.71 14.21c-.274.489-.781.79-1.33.79H3.402l2.661-4.737h9.86zM7.434 5.447l-5.015 8.93-2.213-3.944c-.275-.489-.275-1.09 0-1.58L4.777.715l2.657 4.733z"
            transform="translate(-158 -386) translate(126 23) translate(32 220) translate(0 143) translate(4 5)"
          />
        </g>
      </g>
    </svg>
  );
};

export default GoogleDriveOutline;
